import { useTranslation } from "react-i18next";
import { useEffect, useState, useRef } from "react";
import Axios from "../../Axios";
import ChartLoader, { ChartAreaSubstract, ChartBarLine, ChartBarCompare, ChartGraph, ChartScatter } from "./ChartGraph.tsx";
import ICalendarFactory from "../planning/other/calendar/ICalendarFactory.tsx";
import moment from "moment/moment";
import APIRequest from "../../JS/APIRequest.ts";

export function Chart() {

    const { t } = useTranslation();
    const [inputType, setInputType] = useState('date');
    const [weekend, setweekend] = useState(null);

    const formatDate = (date) => {
        let year = date.getFullYear();
        let res = '';

        switch (inputType) {
            case 'month':
                let month = date.getMonth() + 1;
                if (month < 10) month = '0' + month;
                res = year + '-' + month;
                break;

            case 'number': res = year; break;

            case 'week':
                let week = ICalendarFactory.getWeek(date);
                if (week < 10) week = '0' + week;
                res = year + '-W' + week;
                break;

            default:
                res = ICalendarFactory.TZDateFormat(date);
                break;
        }
        return res;
    }

    const dateFromFormattedDate = (str) => {
        switch (inputType) {
            case 'month': return new Date(str + '-01')
            case 'number': return new Date(str + '-01-01');
            case 'week': return new Date(str.split('-W')[0], 0, (1 + (str.split('-W')[1]) * 7))
            default: return new Date(str)
        }
    }

    const [dateStart, setDateStart] = useState(ICalendarFactory.getMonday(new Date()));
    const [dateEnd, setDateEnd] = useState(new Date(ICalendarFactory.getMonday(new Date()).getTime() + 518400000));
    const [typeDate, setTypeDate] = useState('week');

    const inputRef = useRef(null);

    const [data, setData] = useState([]);

    const [testdata, setTestData] = useState([]);
    const [dataCompare, setDataCompare] = useState([[], []]);

    const [allocatedData, setAllocatedData] = useState([]);
    const [realizedData, setRealizedData] = useState([]);


    const [categories, setCategories] = useState([]);

    const calcHourDifference = (start, end) => {
        let m_start = moment('1970-01-01T' + start)
        let m_end = moment('1970-01-01T' + end)
        let minutes = m_end.diff(m_start, 'minutes')
        return Math.floor((minutes / 60) * 100) / 100

        /*
        let m_start = new Date('1970-01-01T' + start).getTime()
        let m_end = new Date('1970-01-01T' + end).getTime()
        return (Math.floor(((m_end - m_start) / 60000) * 1.667 ) / 100)
        */
    }

    const formatTestData = (data) => {
        console.log(data)
        console.log(typeDate)

        let tpm_tab = [...Array(categories.length)].map((_, i) => 0)
        let data_tree = {
            'COMING': [...tpm_tab],
            'LATE': [...tpm_tab],
            'ABORTED': [...tpm_tab],
            'DONE': [...tpm_tab],
            'EFFECTUED': [...tpm_tab]
        }

        let realizedDataTree = {
            'LEAD_TIME_REALIZED': [...tpm_tab],
            'TPS_REALIZED': [...tpm_tab],
            'TPS_WORK_REALIZED': [...tpm_tab]
        }
        let allocatedDataTree = {
            'LEAD_TIME_ALLOCATED': [...tpm_tab],
            'TPS_ALLOCATED': [...tpm_tab],
            'TPS_WORK_ALLOCATED': [...tpm_tab]
        }

        data.forEach(row => {
            let day = 0;
            switch (typeDate) {

                case 'month':
                    day = new Date(row.date).getDate() - 1;
                    break;

                case 'number': break;

                case 'week':
                    day = new Date(row.date).getDay() - 1;
                    if (day < 0) day = 6;
                    break;

                default:
                    day = new Date(row.date).getDay() - 1;
                    if (day < 0) day = 6;
                    break;
            }

            data_tree[row.status][day] += calcHourDifference(row.hourly_start, row.hourly_end);
            data_tree['EFFECTUED'][day] += calcHourDifference(row.dateStart, row.dateEnd);

            allocatedDataTree['LEAD_TIME_ALLOCATED'][day] += calcHourDifference(row.hourly_start, row.hourly_end);
            allocatedDataTree['TPS_ALLOCATED'][day] += allocatedDataTree['LEAD_TIME_ALLOCATED'][day];                 //TODO add breaks
            allocatedDataTree['TPS_WORK_ALLOCATED'][day] += (allocatedDataTree['TPS_ALLOCATED'][day] * row.actions.length);  //TODO get count instead of actions.length

            realizedDataTree['LEAD_TIME_REALIZED'][day] += calcHourDifference(row.dateStart, row.dateEnd);
            realizedDataTree['TPS_REALIZED'][day] += row.actions.reduce((acc, action) => acc + (calcHourDifference(action.dateStart, action.dateEnd)), 0,);
            realizedDataTree['TPS_WORK_REALIZED'][day] += row.actions.reduce((acc, action) => acc + (calcHourDifference(action.dateStart, action.dateEnd) - (action.tps_break / 3600000)), 0,);
            console.log(row.actions.map(act => (act.tps_break / 3600000)))
        });

        let res = [
            { name: 'COMING', data: data_tree['COMING'] },
            { name: 'LATE', data: data_tree['LATE'] },
            { name: 'ABORTED', data: data_tree['ABORTED'] },
            { name: 'DONE', data: data_tree['DONE'] },
            { name: 'EFFECTUED', data: data_tree['EFFECTUED'] }
        ]

        let allocated = [
            { name: 'LEAD_TIME_ALLOCATED', data: allocatedDataTree['LEAD_TIME_ALLOCATED'] },
            { name: 'TPS_ALLOCATED', data: allocatedDataTree['TPS_ALLOCATED'] },
            { name: 'TPS_WORK_ALLOCATED', data: allocatedDataTree['TPS_WORK_ALLOCATED'] }
        ];

        let realized = [
            { name: 'LEAD_TIME_REALIZED', data: realizedDataTree['LEAD_TIME_REALIZED'] },
            { name: 'TPS_REALIZED', data: realizedDataTree['TPS_REALIZED'] },
            { name: 'TPS_WORK_REALIZED', data: realizedDataTree['TPS_WORK_REALIZED'] }
        ]

        console.log(res)
        setTestData(res);
        setAllocatedData(allocated);
        setRealizedData(realized);
    }

    const fetchData = async () => {
        setweekend(await APIRequest.getSettingValueByName('show weekend'))

        console.log(
            ICalendarFactory.TZDateFormat(dateStart),
            ICalendarFactory.TZDateFormat(dateEnd)
        )
        const response = await Axios.get(`/api/fp/chart/getchartfromdates`, {
            headers: {
                "Content-Type": "application/json",
                "auth-token": sessionStorage.getItem('token')
            },
            params: {
                dateStart: ICalendarFactory.TZDateFormat(dateStart),
                dateEnd: ICalendarFactory.TZDateFormat(dateEnd)
            },
            withCredentials: true
        });
        console.log(response.data)
        setData(response.data)

    }


    useEffect(() => {
        fetchData()
    }, [, dateStart, dateEnd]);

    useEffect(() => {
        formatTestData(data)
        setDataCompare(generateDataCompare(50));
    }, [data]);

    const setDate = (dateStart) => {
        console.log(typeDate)
        switch (typeDate) {
            case 'week': {
                dateStart = ICalendarFactory.getMonday(dateStart)
                setDateStart(dateStart);
                setDateEnd(new Date(dateStart.getTime() + 518400000));

                let cat = ["monday", "tuesday", "wednesday", "thursday", "friday"];
                if (weekend) cat.push("saturday", "sunday")
                setCategories(cat)

                break;
            }
            case 'month': {
                setDateStart(new Date(dateStart.getFullYear(), dateStart.getMonth(), 1));
                setDateEnd(new Date(dateStart.getFullYear(), dateStart.getMonth() + 1, 0));

                setCategories([...Array(
                    new Date(dateStart.getFullYear(), dateStart.getMonth() + 1, 0).getDate()
                )].map((_, i) => i + 1));

                break;
            }
            case 'year': {
                setDateStart(new Date(dateStart.getFullYear() + '-01-01'));
                setDateEnd(new Date((dateStart.getFullYear() + 1) + '-01-01'));
                break;
            }
            default: {
                setDateStart(dateStart);
                setDateEnd(dateStart);
                break;
            }
        }
    }



    useEffect(() => {
        switch (typeDate) {
            case 'week':
                setInputType('week');
                break;
            case 'month':
                setInputType('month');
                break;
            case 'year':
                setInputType('number'); // input type for year is 'number'
                break;
            default:
                setInputType('date');
        }
        setDate(dateStart);
    }, [typeDate]);


    function generateDataCompare(nb = 100) {
        const variation = 3
        const target_value = 10

        let acc = 0;
        let vecs = Array(nb).fill().map(i => {
            acc += (Math.random() * (100 * variation) - (50 * variation));
            return Math.floor(acc) / 100
        })
        let avg = (vecs.reduce((accu, vec) => accu + vec, 0)) / vecs.length

        while (avg > (0.2 * variation)) {
            vecs = vecs.map(vec => Math.floor((vec - (0.05 * variation)) * 100) / 100)
            avg = (vecs.reduce((accu, vec) => accu + vec, 0)) / vecs.length
        }
        while (avg < -(0.2 * variation)) {
            vecs = vecs.map(vec => Math.floor((vec + (0.05 * variation)) * 100) / 100)
            avg = (vecs.reduce((accu, vec) => accu + vec, 0)) / vecs.length
        }

        // vecs = vecs.map(v => v < 0 ? 0 : v)

        acc = target_value
        let data1 = Array(nb).fill().map(i => Math.floor(Math.random() * 200 - 100) / 100).map(v => { acc += v; return Math.floor(acc * 100) / 100 })
        let data2 = vecs.map((v, i) => Math.floor((data1[i] + v) * 100) / 100)


        return [data1, data2];
    }


    return (
        <div className="w-full h-full flex flex-col items-center">
            <div className="w-full h-full flex inline-flex ml-0">
                <div className="flex flex-col items-center shadow px-2 py-2 border border-gray-300 w-48">
                    <div className="w-full ">
                        <div className=" w-full text-left">
                            <label className="text-gray-800 my-2">{t('type date')}</label>
                            <select
                                className="border border-gray-300 rounded w-full my-1"
                                value={typeDate}
                                onChange={(e) => setTypeDate(e.target.value)}
                            >
                                <option value="day">{t('day')}</option>
                                <option value="week">{t('week')}</option>
                                <option value="month">{t('month')}</option>
                                <option value="year">{t('year')}</option>
                            </select>
                        </div>
                        <div className=" w-full border border-gray-300 rounded p-1 my-2">
                            <div className="w-full flex space-x-10">
                                {/*
                                <label className="text-gray-800">{t('date range')}</label>
                                <label className="flex items-center cursor-pointer place-self-center">
                                    <input type="checkbox" value="" checked={isRange} className="sr-only peer" onChange={e => setIsRange(e.target.checked)} />
                                    <div className="relative w-11 h-6 bg-gray-200 rounded-full peer bg-gray-500 peer-checked:after:translate-x-full rtl:peer-checked:after:-translate-x-full peer-checked:after:border-white after:content-[''] after:absolute after:top-[2px] after:start-[2px] after:bg-white after:border-gray-300 after:border after:rounded-full after:h-5 after:w-5 after:transition-all  peer-checked:bg-blue-600"></div>
                                </label>

                                */}
                            </div>

                            <div className="w-full  my-2">
                                <label className="text-gray-800 ">{t(typeDate)}</label>
                                <input
                                    type={inputType}
                                    ref={inputRef}
                                    className="border border-gray-300 rounded mt-1 w-full "
                                    value={formatDate(dateStart)}
                                    onChange={(e) => setDate(dateFromFormattedDate(e.target.value))}
                                    onDoubleClick={() => { }}
                                />
                            </div>
                        </div>

                    </div>

                    <button className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600"
                        onClick={console.log}>
                        {t('generate')}
                    </button>
                </div>
                <div className="w-[85%] h-full flex-col flex">

                    <ChartLoader
                        option={ChartBarCompare(
                            [{
                                name: 'Total',
                                subBar: [
                                    testdata[0] ? testdata[0] : { name: '', data: [] },
                                    testdata[1] ? testdata[1] : { name: '', data: [] },
                                    testdata[2] ? testdata[2] : { name: '', data: [] },
                                    testdata[3] ? testdata[3] : { name: '', data: [] }
                                ]
                            }, {
                                name: 'Total2',
                                subBar: [testdata[4] ? testdata[4] : { name: '', data: [] }]
                            }],
                            'graph 16',
                            false,
                            categories
                        )}
                        update={testdata}
                    />

                    <ChartLoader
                        option={ChartAreaSubstract(
                            realizedData[0]?.data,
                            allocatedData[0]?.data,
                            'graph 3_1'
                        )}
                        height={400}
                        update={testdata}
                    />

                    <ChartLoader
                        option={ChartAreaSubstract(
                            realizedData[1]?.data,
                            allocatedData[1]?.data,
                            'graph 3_2'
                        )}
                        height={400}
                        update={testdata}
                    />

                    <ChartLoader
                        option={ChartAreaSubstract(
                            realizedData[2]?.data,
                            allocatedData[2]?.data,
                            'graph 3_3'
                        )}
                        height={400}
                        update={testdata}
                    />

                    <ChartLoader
                        option={ChartAreaSubstract(
                            realizedData[1]?.data,
                            realizedData[2]?.data,
                            'graph 3_pause'
                        )}
                        height={400}
                        update={realizedData}
                    />

                    <ChartLoader
                        option={ChartBarCompare(
                            [
                                {
                                    name: 'allocated',
                                    subBar: [
                                        { name: 'TLA', data: allocatedData[0] ? allocatedData[0].data : [] },
                                        { name: 'TA', data: allocatedData[1] ? allocatedData[1].data : [] },
                                        { name: 'TWA', data: allocatedData[2] ? allocatedData[2].data : [] }
                                    ]
                                },
                                {
                                    name: 'realized',
                                    subBar: [
                                        { name: 'TLR', data: realizedData[0] ? realizedData[0].data : [] },
                                        { name: 'TR', data: realizedData[1] ? realizedData[1].data : [] },
                                        { name: 'TWR', data: realizedData[2] ? realizedData[2].data : [] }
                                    ]
                                },
                            ],
                            'graph 0'
                        )}
                        update={allocatedData}
                    />

                    <ChartLoader
                        option={ChartBarCompare(
                            [{
                                name: 'Total',
                                subBar: realizedData
                            }, {
                                name: 'Total2',
                                subBar: allocatedData
                            }],
                            'graph 17',
                            false,
                            categories
                        )}
                        update={testdata}
                    />


                    <ChartLoader
                        option={
                            ChartGraph(
                                [
                                    testdata[0]?.data,
                                    categories
                                    //Array(50).fill().map(n => Math.floor(Math.random() * 10)),
                                    //Array(50).fill().map((n, i) => i)
                                ],
                                'bar',
                                'graph 1'
                            )
                        }
                        update={testdata}
                    />

                    <ChartLoader
                        option={ChartAreaSubstract(
                            testdata[3]?.data,
                            testdata[4]?.data,
                            'graph 2'
                        )}
                        height={400}
                        update={testdata}
                    />

                    <div className="w-full">
                        <ChartLoader
                            option={ChartAreaSubstract(
                                dataCompare[0],
                                dataCompare[1],
                                'graph 11'
                            )}
                            height={400}
                            update={dataCompare}
                        />

                        <ChartLoader
                            option={ChartBarCompare(
                                [
                                    {
                                        name: 'planified',
                                        subBar: [
                                            { name: 'Baidu', data: [620, 732, 701, 734, 1090, 1130, 1120] },
                                            { name: 'Google', data: [120, 132, 101, 134, 290, 230, 220] },
                                            { name: 'Bing', data: [60, 72, 71, 74, 190, 130, 110] },
                                            { name: 'Others', data: [62, 82, 91, 84, 109, 110, 120] },
                                        ]
                                    },
                                    {
                                        name: 'Faite',
                                        subBar: [
                                            { name: 'Baidu', data: [869, 1029, 970, 1027, 1682, 1607, 1572] },
                                            { name: 'Google', data: [127, 142, 115, 145, 296, 242, 224] },
                                            { name: 'Bing', data: [69, 79, 73, 75, 200, 132, 117] },
                                            { name: 'Others', data: [66, 94, 91, 98, 115, 122, 123] },
                                        ]
                                    },
                                ],
                                'graph 14'
                            )}
                        />

                    </div>
                    <div id="result"
                        className="flex flex-col items-center border border-gray-300 shadow overflow-auto max-h-52">
                        <ul className="list-disc">
                            {/*dataResult.map((element, index) => {



                                return (
                                    <li key={index}
                                        className="flex flex-row items-center justify-between w-full px-4 py-2 border-b border-gray-300 hover:bg-gray-100">
                                        <p className="px-4">{t('date')}: {element.date}, </p>
                                        <p className="px-4">{t('Start hours')}: {element.hourly_start}, </p>
                                        <p className="px-4">{t('End hours')}: {element.hourly_end}, </p>
                                        <p className="px-4">{t('Location')}: {element.location}</p></li>
                                );
                            })*/}
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    );
}
